module.exports = __webpack_public_path__ + "img/b7dc1e8.jpg";